import TutorialVideo from './TutorialVideo'

export default TutorialVideo
